export interface Score {
  fitterId: string;
  globalScore: number;
}
